export const TUTOR_BIO_DEFAULT = 'This person likes to have an air of mystery around them...'
